export default "__VITE_ASSET__ecCL7H$N__"